import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import BackToTop from "./components/BackToTop";
import AwaChat from "./components/AwaChat";
import LandingPage from "./components/LandingPage";

// Pages simplifiées
import Home from "./pages/Home";
import Produits from "./pages/Produits";
import Contact from "./pages/Contact";
import Tracabilite from "./pages/Tracabilite";
import LotDetails from "./pages/LotDetails";
import DialloPage from "./pages/DialloPage";
import B2B from "./pages/B2B";

// Register Service Worker
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service Worker registered:', registration.scope);
    } catch (error) {
      console.log('Service Worker registration failed:', error);
    }
  }
};

function App() {
  const [showLanding, setShowLanding] = useState(() => {
    return !sessionStorage.getItem('oceana_entered');
  });

  useEffect(() => {
    registerServiceWorker();
  }, []);

  const handleEnterSite = () => {
    sessionStorage.setItem('oceana_entered', 'true');
    setShowLanding(false);
  };

  // Show landing page first
  if (showLanding) {
    return (
      <ThemeProvider>
        <LanguageProvider>
          <LandingPage onEnter={handleEnterSite} />
        </LanguageProvider>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="App dark:bg-[#0F1A14] transition-colors duration-300">
          <BrowserRouter>
            <ScrollToTop />
            <Navigation />
            <main className="min-h-screen">
              <Routes>
                {/* Pages principales */}
                <Route path="/" element={<Home />} />
                <Route path="/produits" element={<Produits />} />
                <Route path="/contact" element={<Contact />} />
                
                {/* SmartTrace - Traçabilité */}
                <Route path="/tracabilite" element={<Tracabilite />} />
                <Route path="/tracabilite/:code" element={<LotDetails />} />
                <Route path="/t/:code" element={<LotDetails />} />
                
                {/* Réseau Diallo */}
                <Route path="/diallo" element={<DialloPage />} />
                
                {/* B2B Professionnels */}
                <Route path="/b2b" element={<B2B />} />
                <Route path="/pro" element={<B2B />} />
                
                {/* Anciennes URLs - Redirection vers Home */}
                <Route path="/le-groupe" element={<Home />} />
                <Route path="/nos-metiers" element={<Home />} />
                <Route path="/nos-metiers/*" element={<Home />} />
                <Route path="/produits-saisons" element={<Produits />} />
                <Route path="/qualite" element={<Home />} />
                <Route path="/impact" element={<Home />} />
                <Route path="/carrieres" element={<Contact />} />
                
                {/* Fallback */}
                <Route path="*" element={<Home />} />
              </Routes>
            </main>
            <Footer />
            <AwaChat />
            <BackToTop />
            <Toaster position="top-center" />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
